import React from 'react';
import styles from './NameAndPosition.module.scss';

const NameAndPosition = ({ name, position }) => (
  <React.Fragment>
    <h3 className = { styles.personName }>{ name }</h3>
    <h5 className = { styles.personPosition }>{ position }</h5>
  </React.Fragment>
);

export default NameAndPosition;